export function getVideoFrameDataUrl(url: string, time = 0.1) {
  return new Promise<string>((resolve, reject) => {
    const video = document.createElement('video')
    video.crossOrigin = 'anonymous'
    video.src = url
    video.currentTime = time
    video.muted = true
    video.autoplay = true
    video.playsInline = true

    video.addEventListener('loadeddata', () => {
      try {
        const canvas = document.createElement('canvas')
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        canvas
          .getContext('2d')
          .drawImage(video, 0, 0, canvas.width, canvas.height)
        const dataUrl = canvas.toDataURL()
        resolve(dataUrl)
      } catch {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('')
      }
    })

    video.addEventListener('error', () => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('')
    })
  })
}
